import React from "react";
import { any, async, fromJSX, IOWidget, Option, Redirect, unloadedAsyncState, Updater } from "widgets-for-react";
import { RedirectResult, RedirectState } from "./redirectState";



const isRedirected = (destination: string) : boolean  => {
  const dest = new URL(
    !destination.startsWith('http')
      ? `${window.location.protocol}//${window.location.host}${destination}`
    : destination
  )

  const source = new URL(window.location.href)

  let query : boolean = true
  dest.searchParams.forEach((v,k) => {
    if (v !== source.searchParams.get(k)) {
      query = false
    }
  })

  return dest.pathname === source.pathname && query
}

export const redirectWidget : IOWidget<RedirectState, Updater<RedirectState>>= (s: RedirectState) => 
  any<Updater<RedirectState>>([
    async<Option<RedirectResult>>(s.redirect, r => {     
      return fromJSX(setState => {
        if (r.kind === 'l' || isRedirected(r.v.NewSlug)) {
          setState(s => unloadedAsyncState())
          return <></>
        }
        return <Redirect to={r.v.NewSlug} />
      }) // check if redirect has been found
    }).map(updater => os => ({
      ...s,
      redirect: updater(os.redirect)
    }))
  ])